$(function () {
    morningstarTable = {
        endpoint: '/Main/YieldNetFlowsBlock/GetYieldNetFlowsData',
        tableData: {},
        tableHeaderArray: ["Category", "OneMonth", "Qtd", "Ytd", "OneYear"],
        tableClassesArray: ["text-left", "", "", ""],
        tableHeaderTitleArray : ["Category", "1-Mo", "QTD", "YTD", "1-Yr"],
        retrieved: false,
        wrapperDiv: $('#veMorningstarFlowsTable'),
        isExcelDownloading: false,
        toggleEventListenersAdded: false,
        deskTopTableDiv: "MorningstarDesktopTable",
        blockId: $('#veMorningstarFlowsTable').attr("data-blockid"),

        init: async () => {
            commonFundUtils.spinner.show("MorningstarDesktopTable");
            morningstarTable.tableData = await commonFundUtils.getData(morningstarTable.blockId, morningstarTable.endpoint)
            morningstarTable.drawTable()
            morningstarTable.drawMobileTable()
            commonFundUtils.spinner.hide("MorningstarDesktopTable");
        },
        //draw the table
        drawTable: async () => {
            await commonFundUtils.drawDesktopTable(
                "veMorningstarFlowsTable",
                "MorningstarDesktopTable",
                morningstarTable.tableData,
                morningstarTable.drawHeader,
                morningstarTable.tableData,
            )
            morningstarTable.drawBlock(morningstarTable.tableData.Items)
            morningstarTable.enableHeaderClicks()
        },
        //used to draw the table header
        drawHeader: (dataSet) => {
            var tableheader='';
            tableheader = '<thead>';
            tableheader += '<tr><th></th><th colspan="4" style="border-bottom: 1px solid;">' + dataSet.SecondColumnName + '</th></tr>';
            tableheader += '<tr>'
                + '<th id="Category" class="text-left table-header-item ' + commonFundUtils.getUnderlinedClass("veMorningstarFlowsTable", "Category") + '"><span class="table-thead d-inline-flex">' + dataSet.FirstColumnName + commonFundUtils.sortIconMarkup + '</span></th>'
                + '<th id="OneMonth" class="table-header-item ' + commonFundUtils.getUnderlinedClass("veMorningstarFlowsTable", "OneMonth") + '"><span class="table-thead d-inline-flex">1-MO' + commonFundUtils.sortIconMarkup +'</span></th>'
                + '<th id="Qtd" class="table-header-item ' + commonFundUtils.getUnderlinedClass("veMorningstarFlowsTable", "Qtd") + '"><span class="table-thead d-inline-flex">QTD' + commonFundUtils.sortIconMarkup +'</span></th>'
                + '<th id="Ytd" class="table-header-item ' + commonFundUtils.getUnderlinedClass("veMorningstarFlowsTable", "Ytd") + '"><span class="table-thead d-inline-flex">YTD' + commonFundUtils.sortIconMarkup +'</span></th>'
                + '<th id="OneYear" class="table-header-item ' + commonFundUtils.getUnderlinedClass("veMorningstarFlowsTable", "OneYear") + '"><span class="table-thead d-inline-flex">1-Yr' + commonFundUtils.sortIconMarkup +'</span></th>'
                + '</tr>' 
            tableheader += '</thead>';
            return tableheader;
        },
        //this block is used to draw the body of the table for both 
        drawBlock: (dataSet, isExcel) => {
            //$('#veMorningstarFlowsTable table tbody').remove();
            var tableBlock='';
            tableBlock += '<tbody>';
            tableBlock += commonFundUtils.drawItemsInGroup(dataSet, morningstarTable.tableClassesArray, morningstarTable.tableHeaderArray,false ,isExcel)
            tableBlock += '</tbody>';
            if (isExcel) {
                morningstarTable.isExcelDownloading = false
                //morningstarTable.drawTable()
                return tableBlock
            } else {
                $('#veMorningstarFlowsTable table').append(tableBlock);
            }
        },
        enableHeaderClicks: () => {
            $('#veMorningstarFlowsTable .table-header-item').on("click", function () {
                commonFundUtils.changeDivAttributes(this, morningstarTable.wrapperDiv)
                morningstarTable.tableData.Items = commonFundUtils.sortData(morningstarTable.tableData.Items, morningstarTable.wrapperDiv)
                morningstarTable.drawTable()
            })
            //to run the excel button click event listner only once
            if (morningstarTable.toggleEventListenersAdded) return
            //activating the "download excel" button click only once
            commonFundUtils.generateExcelTable("veMorningstarFlowsTable", morningstarTable.drawExcelTable)
            morningstarTable.toggleEventListenersAdded = true
        },
        drawMobileTable: () => {
            var mobileTable = '';
            mobileTable += '<div class="d-lg-none">'
                + '<div class="fund-listing-table table-mobile" id="MorningstarTableMobileBlock">'
            mobileTable += morningstarTable.drawMobileCardArray(morningstarTable.tableData, 1, morningstarTable.tableHeaderArray)
            if ($('#veMorningstarFlowsTable .table-mobile .table-footer').length == 0 && morningstarTable.tableData.FooterText !== null) {
                mobileTable += '<div class="table-footer mt-3">' + morningstarTable.tableData.FooterText + '</div>';
            }
            mobileTable += '</div></div>'
            $(morningstarTable.wrapperDiv).append(mobileTable);
        },
        drawMobileCardArray: (dataSet, headerColumns, headerArray) => {
            var mobileCard = '';
            $.each(dataSet.Items, function (index) {
                mobileCard += '<div class="fund-explorer-table__card">';
                mobileCard += commonFundUtils.drawMobileHeader(this, headerColumns, headerArray)
                mobileCard += '<div class="row">'
                mobileCard += '<div class=" fund-explorer-table__card-body col-12"><div class="fund-explorer-table__card-column ">' + dataSet.SecondColumnName + '</div></div>'
                mobileCard += commonFundUtils.drawMobileItems(this, 1, headerArray.length, headerArray, morningstarTable.tableHeaderTitleArray)
                mobileCard += '</div>'
                mobileCard += '</div>'
            })
            return mobileCard;
        },
        drawExcelTable: (wrapperDiv) => {
            var excelTable = '';
            morningstarTable.isExcelDownloading = true
            $('#excelDrawArea table').remove();
            excelTable += '<table class="d-none excel-table" border="1">';
            excelTable += morningstarTable.drawHeader(morningstarTable.tableData)
            excelTable += morningstarTable.drawBlock(morningstarTable.tableData.Items, morningstarTable.isExcelDownloading)
            excelTable += '</table>';
            $('#excelDrawArea').append(excelTable);
            commonFundUtils.downloadExcelReport(wrapperDiv);
        }
        
    }
    //function is only initiated if the block ID is a number
    if (!isNaN(morningstarTable.blockId)) {
        morningstarTable.init()
    }
})